import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Public pages
import HomePageNew from './pages/HomePageNew';
import ContactsPage from './pages/ContactsPage';
import InstitucionalPage from './pages/InstitucionalPage';
import ElogiosReclamacoesPage from './pages/ElogiosReclamacoesPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiesPolicyPage from './pages/CookiesPolicyPage';
import ProjectsPage from './pages/ProjectsPage';
import InterventionPage from './pages/InterventionPage';
import NewsPage from './pages/NewsPage';
import DonationSuccessPage from './pages/DonationSuccessPage';
import DonativosPage from './pages/DonativosPage';
import CareersPage from './pages/CareersPage';
import EventsPage from './pages/EventsPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminLogin from './pages/AdminLogin';

// Admin pages
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminNews from './pages/AdminNews';
import AdminNewsForm from './pages/AdminNewsForm';
import AdminSubmissions from './pages/AdminSubmissions';
import AdminDocuments from './pages/AdminDocuments';
import AdminCMS from './pages/AdminCMS';
import AdminCandidaturas from './pages/AdminCandidaturas';
import AdminEvents from './pages/AdminEvents';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>A carregar...</div>;
  }
  
  return user ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePageNew />} />
            <Route path="/contactos" element={<ContactsPage />} />
            <Route path="/institucional" element={<InstitucionalPage />} />
            <Route path="/elogios-reclamacoes" element={<ElogiosReclamacoesPage />} />
            <Route path="/politica-privacidade" element={<PrivacyPolicyPage />} />
            <Route path="/politica-cookies" element={<CookiesPolicyPage />} />
            <Route path="/projetos" element={<ProjectsPage />} />
            <Route path="/intervencao" element={<InterventionPage />} />
            <Route path="/noticias" element={<NewsPage />} />
            <Route path="/noticias/:slug" element={<NewsPage />} />
            <Route path="/donativo-sucesso" element={<DonationSuccessPage />} />
            <Route path="/donativos" element={<DonativosPage />} />
            <Route path="/carreiras" element={<CareersPage />} />
            <Route path="/eventos" element={<EventsPage />} />
            
            {/* Admin Login */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Protected Admin Routes */}
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<AdminDashboard />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="news/new" element={<AdminNewsForm />} />
              <Route path="news/edit/:id" element={<AdminNewsForm />} />
              <Route path="documents" element={<AdminDocuments />} />
              <Route path="submissions" element={<AdminSubmissions />} />
              <Route path="candidaturas" element={<AdminCandidaturas />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="cms" element={<AdminCMS />} />
            </Route>
            
            {/* 404 - Catch all */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
    </HelmetProvider>
  );
}

export default App;